import React from "react";

const PHRASES = [
    "You were invited.",
    "Somebody recognizes your DOPENESS.",
    "Builders, not beggars.",
    "Relationships over cold pitches.",
    "Warm introductions, not cold pitches.",
];

const InvitationMarquee = () => {
    const content = [...PHRASES, ...PHRASES, ...PHRASES];
    return (
        <section
            data-testid="invitation-callout"
            className="relative border-y border-[#d4af37]/25 bg-gradient-to-r from-[#d4af37] via-[#f2c652] to-[#d4af37] text-[#0a0c27] py-5 md:py-6 overflow-hidden"
        >
            <div className="flex whitespace-nowrap dn-marquee-track">
                {content.map((phrase, i) => (
                    <span
                        key={i}
                        className="font-display font-black text-[28px] md:text-[42px] tracking-tight uppercase mx-6 inline-flex items-center gap-6"
                        data-testid={`marquee-phrase-${i}`}
                    >
                        {phrase}
                        <span className="text-[#0a0c27]/40">✦</span>
                    </span>
                ))}
            </div>
        </section>
    );
};

export default InvitationMarquee;
